import type { Career } from "@/payload-types";

export type Market = "UK" | "US";

// Docs saved before the market field existed count as UK.
export const marketOf = (career: Career): Market =>
  career.location?.market === "US" ? "US" : "UK";
